


























































































import { Vue, Component } from 'vue-property-decorator';
import { utils, writeFileXLSX } from 'xlsx';
import readXlsFile from 'read-excel-file';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import moment from 'moment';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
@Component({
  components: {
    MantenedorGrid,
  },
})
export default class LecturaExcel extends Vue {
  fileName = '';
  idkey = 0;
  itemsDelExcel: any = {};
  gridOptions: GridOptions;
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  serverSide: any;

  $snotify: any;

  beforeDestroy() {
    this.quitarRegistro();
  }

  quitarRegistro() {
    this.fileName = '';
    this.itemsDelExcel = {};
    this.loadRows([]);
    this.$emit('sinExcel');
  }
  errorArchivo: boolean = false;
  subirExcel() {
    let input = <HTMLInputElement>document.getElementById('archivoExcel');
    this.fileName = input.files[0].name;
    readXlsFile(input.files[0])
      .then(rows => {
        this.itemsDelExcel = { ...rows };
        let datos = [...rows];
        if (datos.length == 0) {
          this.$snotify.warning('Por favor verifique el excel');
          this.errorArchivo = true;
          return;
        }
        datos = datos.splice(1);
        if (!datos[1]) {
          this.$snotify.warning('Por favor verifique el excel');
          return;
        }
        let items = datos.map((item: any) => {
          return {
            simSerie: item[0],
            simPrefijo: item[1],
            simMovil: item[2],
            fechaPovision: moment(item[3]).add(1, 'days'),
            simTama: item[4],
            simApn: item[5],
            simEstado: item[6],
          };
        });
        this.loadRows(items);
        this.$emit('excel', this.itemsDelExcel);
      })
      .catch(() => {
        this.itemsDelExcel = {};
        this.$snotify.warning(
          'Verifique el archivo. Debe tener formato: .CSV, .XLS o .XLSX',
          3000
        );
      });
    this.idkey += 1;
  }

  descargarPlantilla() {
    let headers = {
      header: [
        'SIM Serie Número',
        'SIM Prefijo',
        'SIM Móvil',
        'Fecha de Provisión',
        'SIM Tamaño',
        'SIM APN',
        'SIM Estado',
      ],
    };
    let datos: any = [
      {
        'SIM Serie Número':
          'Ejemplo: 8881115552229994447 (IMPORTANTE: Esta columna NO permite repetidos ni campos vacíos)',
        'SIM Prefijo': 'Ejemplo: 919191',
        'SIM Móvil': 'Ejemplo: 333777000444000',
        'Fecha de Provisión': 'Ejemplo: 30/12/2020',
        'SIM Tamaño': 'Ejemplo: Estándar',
        'SIM APN': 'Ejemplo: m2m.movistar.cl',
        'SIM Estado': 'Ejemplo: Activado/Desactivado',
      },
    ];
    const ws = utils.json_to_sheet(datos, headers);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Plantilla');
    writeFileXLSX(wb, 'PlantillaAltaSIM.xlsx');
    this.$snotify.success('Plantilla Excel descargada con éxito', 3000);
  }

  //--------------------- Tabla ------------------------------
  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
  }
  cargarTabla: boolean = false;
  async loadRows(data: Array<any>) {
    this.cargarTabla = data.length > 0;
    this.gridApi.setRowData(data);
    this.gridApi.setDomLayout('autoHeight');
  }

  dateFormatter(params: any) {
    return moment(params.value).format('DD-MM-YYYY');
  }

  constructor() {
    super();
    this.columnDefs = [
      {
        headerName: 'Sim Serie',
        field: 'simSerie',
        resizable: true,
        sortable: true,
        width: 400,
        lockPinned: true,
      },
      {
        headerName: 'Sim Prefijo',
        field: 'simPrefijo',
        resizable: true,
        sortable: true,
        width: 400,
        lockPinned: true,
      },
      {
        headerName: 'Sim Móvil',
        field: 'simMovil',
        resizable: true,
        sortable: true,
        width: 400,
        lockPinned: true,
      },
      {
        headerName: 'Fecha Provisión',
        field: 'fechaPovision',
        resizable: true,
        sortable: true,
        width: 400,
        lockPinned: true,
        valueFormatter: this.dateFormatter,
      },
      {
        headerName: 'Sim Tamaño',
        field: 'simTama',
        resizable: true,
        sortable: true,
        width: 400,
        lockPinned: true,
      },
      {
        headerName: 'Sim APN',
        field: 'simApn',
        resizable: true,
        sortable: true,
        width: 400,
        lockPinned: true,
      },
      {
        headerName: 'Sim Estado',
        field: 'simEstado',
        resizable: true,
        sortable: true,
        width: 400,
        lockPinned: true,
      },
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 6, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          //cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }
  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }
}
